.linkbutton {
  &:hover {
    color: #fff;
  }
}

// From: https://codepen.io/scottloway/pen/grgJgB
.linkUnstyled {
  &,
  &:visited,
  &:hover,
  &:active,
  &:focus,
  &:active:hover {
    font-style: inherit!important;
    color: inherit!important;
    background-color: transparent!important;
    font-size: inherit!important;
    text-decoration: none!important;
    font-variant: inherit!important;
    font-weight: inherit!important;
    // line-height: inherit!important;
    font-family: inherit!important;
    border-radius: inherit!important;
    border: inherit!important;
    outline: inherit!important;
    box-shadow: inherit!important;
    padding: inherit!important;
    vertical-align: inherit!important;
  }
}

.linkMinimumStyle {
  @extend .linkUnstyled;

  // &:hover {
  //   text-decoration: underline!important;
  // }
  &:active {
    filter: brightness(0.75);
  }
}